// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__7K1Be","ui-modal-rise":"Modal_ui-modal-rise__TnWU5"};